import { useEffect } from "react";

import { useAnimation, motion } from "framer-motion";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { RichTextContent } from "@graphcms/rich-text-types";

interface FaqProps {
  isOpen: boolean;
  id: string;
  question: string;
  answerRaw?: RichTextContent;
  onClick: () => void;
}

const Faq = ({ isOpen, id, question, answerRaw, onClick }: FaqProps) => {
  const controls = useAnimation();

  const variants = {
    expanded: { opacity: 1, height: "auto" },
    collapsed: { opacity: 0, height: 0 },
  };

  useEffect(() => {
    if (isOpen) {
      controls.start("expanded");
    } else {
      controls.start("collapsed");
    }
  }, [controls, isOpen]);

  return (
    <div className="border-b border-lightCharcoal py-[20px]">
      <h2
        id={`accordion-flush-heading-${id}`}
        className="text-base font-semibold md:text-md"
      >
        <button
          type="button"
          className={`flex w-full items-center justify-between ${
            isOpen ? "mb-[20px]" : ""
          }`}
          data-accordion-target={`accordion-flush-body-${id}`}
          aria-expanded="true"
          aria-controls={`accordion-flush-body-${id}`}
          onClick={onClick}
        >
          <span className="text-left">{question}</span>
          <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`${
              isOpen ? "rotate-180" : ""
            } ml-[15px] shrink-0 transition duration-200`}
          >
            <path
              d="M1 7.5H14"
              stroke="#735AEE"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.5 1V14"
              stroke="#735AEE"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={`${isOpen ? "opacity-0" : ""} transition duration-200`}
            />
          </svg>
        </button>
      </h2>
      <motion.div
        initial="collapsed"
        id={`accordion-flush-body-${id}`}
        className={`overflow-hidden`}
        aria-labelledby={`accordion-flush-heading-${id}`}
        animate={controls}
        transition={{ duration: 0.3 }}
        variants={variants}
      >
        <div className="py-[5px] pr-[20px]">
          {answerRaw && <RichText content={answerRaw} />}
        </div>
      </motion.div>
    </div>
  );
};

export default Faq;
